export default __webpack_public_path__ + "static/media/linkedin.55f2dae4.svg";